<dialog
    ctrlModal
    (onClose)="dismiss.emit(undefined)"
    (clickOutside)="dismiss.emit(undefined)"
    aria-labelledby="add-file-attachement-modal-title"
>
    <ng-container ctrlModalHeader>
        <h3
            id="add-file-attachement-modal-title"
            class="m-0:b semibold"
        >
            <i
                ctrlIcon="add"
                class="m-16:r"
            >
            </i
            ><span>Datei hinzufügen ({{ currentFileNo() }}&nbsp;von&nbsp;{{ totalFileNo() }})</span>
        </h3>
        <button
            class="close-button button p-0"
            aria-label="Schließen"
            (click)="dismiss.emit(undefined)"
        >
            <i ctrlIcon="close"></i>
        </button>
    </ng-container>

    <hr class="ctrl-modal-hr" />

    @if (file()) {
        @if (imgSrc()) {
            <img
                [src]="imgSrc()"
                [title]="file().file.name"
                [alt]="file().file.name"
            />
        } @else {
            <div class="pdf-icon">
                <i
                    ctrlIcon="pdf"
                    class="c:blue-700"
                ></i>
            </div>
        }
        <p class="c:blue-700 m-16:t m-16:b md:m-24:b">{{ file().file.name }}</p>
        <form [formGroup]="form">
            <div class="form-control">
                <label for="doc-type">Dokumententyp*:</label>
                <select
                    formControlName="documentTypeId"
                    id="doc-type"
                >
                    <option
                        disabled="disabled"
                        [value]="null"
                    >
                        Bitte wählen
                    </option>
                    @for (typeOption of docTypeOptions(); track $index) {
                        <option [ngValue]="typeOption.id">
                            {{ typeOption.description }}
                        </option>
                    }
                </select>
            </div>
            <div class="form-control">
                <label for="description">Anmerkungen</label>
                <textarea
                    formControlName="description"
                    id="description"
                    autoresize
                    placeholder="Anmerkungen"
                ></textarea>
            </div>

            <app-required-info />
        </form>
    }

    <div
        ctrlModalFooter
        class="md:m-24:t"
    >
        <app-portal-action-buttons
            confirmText="Auswählen"
            rejectText="Abbrechen"
            [isConfirmDisabled]="!form.valid"
            (clickConfirm)="onSubmit()"
            (clickReject)="dismiss.emit(undefined)"
            [isUsedToSubmitForm]="true"
        />
    </div>
</dialog>
